import { InjectionToken } from '@angular/core';

import { IExportBrandingOptions } from './export-branding';

/**
 * Injection token for the document chrome applied to generated files.
 */
export const EXPORT_BRANDING = new InjectionToken<IExportBrandingOptions>('EXPORT_BRANDING');
